import { Component, OnInit } from '@angular/core';

import { Input, Output, EventEmitter } from '@angular/core';

import { FormGroup, FormControl } from '@angular/forms';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Router } from '@angular/router';

import * as sha1 from 'js-sha1';


const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type': 'application/json',
    }
  )
};

interface UserInput {
    iduser: number;
    prenom: string;
} ;



@Component({
  selector: 'app-authentification',
  templateUrl: './authentification.component.html',
  styleUrls: ['./authentification.component.css']
})
export class AuthentificationComponent implements OnInit {

   login = "" ;
   pwd = "" ;

   mustChangepwd = 0 ;
   nwpwd = "" ;
   nwpwdconfirmed = "" ;

   erreurLogin = 0 ;
   erreurCoher = 0 ;

   fdg : any ; 
  canOnlyPrepay = false ;

  ROUTES = [] ;

  //PROD
  baseLink = 'https://djolof.sentelecom.com/_api/assurance/courtier/' ;
  
  //DEV
  //baseLink = 'https://devdjolof.hybraine.com/assurance/courtier/' ;


  constructor(private http: HttpClient, private router: Router) { }

  ngOnInit(): void {
  }


  farLogin(){    
    let logdata = {login: this.login , pwd: sha1(this.pwd) } ;  

    // Code to deCommente for dev purposes under airplane mode (no network)

   //this.router.navigate(['/homecpnt']) ;
    this.remotelogger(this.baseLink+'yeurrlouBO.php', logdata ).subscribe(
      retourPost => {
        
        console.log("RetourPost: ", retourPost) ;

        if (retourPost["statutreq"]!=undefined && retourPost["statutreq"]==1){
          this.erreurLogin = 0 ;

          sessionStorage.setItem("profil", retourPost["data"].profil.toString()) ;
          sessionStorage.setItem("compliances", retourPost["data"].compliances) ;
          sessionStorage.setItem("samacaabiyoonwii", retourPost["data"].token.toString()) ;
          sessionStorage.setItem("agence", retourPost["data"].agence.toString()) ;
          sessionStorage.setItem("codeemetteur", retourPost["data"].code.toString()) ;

          if (retourPost["data"].firstuse!=1){
           let usrInfos = retourPost ;
           this.diottCiYoonYimaSagnaDieul( retourPost["data"].profil.toString(), retourPost["data"].compliances);
           this.router.navigate([ this.ROUTES[0].path ]) ;
          }else{
            this.mustChangepwd = 1 ;
            this.fdg = retourPost["data"].profil ;
          }
        }
        else{
          console.log("FAILED: ", retourPost) ;
          this.erreurLogin = 1 ;
        }
    } ) ;             
  }

  isOnlyPrepaidAuthorized(compliances){
    let allOfThem = JSON.parse(compliances) ;
    this.canOnlyPrepay = false ;
    for (var i = 0; i < allOfThem.length; i++) {
        if(allOfThem[i].name=="solde_impaye")
            this.canOnlyPrepay = Number(allOfThem[i].valeur)<=0 ;
    }
  }


  diottCiYoonYimaSagnaDieul(profil, compliances){
    console.log("Profil: ", profil);

    //let compliances = sessionStorage.getItem("compliances") ;
    if(profil=="SOUS-BUREAU"){
      this.ROUTES = [
          { path: '/homecpnt/agence', title: 'Comparateur',  icon:'content_paste', class: '' },
          { path: '/homecpnt/histotransact', title: 'Reporting',  icon:'library_books', class: '' },
          { path: '/homecpnt/crm', title: 'CRM',  icon:'folder', class: '' },
      ];      
    }else if(profil.includes("Gestion")){
      this.ROUTES = [
            { path: '/homecpnt/dashboard', title: 'Dashboard',  icon: 'dashboard', class: '' },
             { path: '/homecpnt/sousreseau', title: 'Sous-Réseau',  icon:'person', class: '' },
            { path: '/homecpnt/histotransact', title: 'Reporting',  icon:'library_books', class: '' },
            //{ path: '/homecpnt/partners', title: 'Partenaires',  icon: 'toc', class: '' },
      ];      
    }
    else{
      this.isOnlyPrepaidAuthorized(compliances) ;
      if(this.canOnlyPrepay==false){
        this.ROUTES = [
            { path: '/homecpnt/dashboard', title: 'Dashboard',  icon: 'dashboard', class: '' },
            { path: '/homecpnt/agence', title: 'Comparateur',  icon:'content_paste', class: '' },
            { path: '/homecpnt/sousreseau', title: 'Sous-Réseau',  icon:'person', class: '' },
            { path: '/homecpnt/versement', title: 'Versements',  icon:'content_paste', class: '' },
            { path: '/homecpnt/histotransact', title: 'Reporting',  icon:'library_books', class: '' },
            { path: '/homecpnt/crm', title: 'CRM',  icon:'folder', class: '' },
        ];
      }else{
        this.ROUTES = [
            { path: '/homecpnt/dashboard', title: 'Dashboard',  icon: 'dashboard', class: '' },
            { path: '/homecpnt/agence', title: 'Comparateur',  icon:'content_paste', class: '' },
            { path: '/homecpnt/sousreseau', title: 'Sous-Réseau',  icon:'person', class: '' },
            { path: '/homecpnt/appeldefonds', title: 'Appel De Fonds',  icon:'content_paste', class: '' },
            { path: '/homecpnt/histotransact', title: 'Reporting',  icon:'library_books', class: '' },
            { path: '/homecpnt/crm', title: 'CRM',  icon:'folder', class: '' },
        ];      
      }      
    }

    sessionStorage.setItem("yoonyifiam", JSON.stringify(this.ROUTES)) ;
  }



  updatePwd(){

    if (this.nwpwdconfirmed!=this.nwpwd)
      this.erreurCoher = 1 ;
    else{
      let updtedata = {login: this.login , nwpwd:  sha1(this.nwpwd) } ;       
      this.erreurCoher = 0 ;

      this.remoteupdtepwd(this.baseLink+'sopandikouleiCaabi.php', updtedata).subscribe(
          retourPost => {
            if (retourPost["statutreq"]!=undefined && retourPost["statutreq"]==1 ){
              this.login = "" ;
              this.pwd = "" ;
              this.mustChangepwd = 0 ;
            }
            else
              console.log("FAILED Update") ;
      } ) ;

    }
  }

  remotelogger(url: string, user: any) {
    return this.http.post(url, user, httpOptions);
  }

  remoteupdtepwd(url: string, user: any) {
    return this.http.post(url, user, httpOptions);
  }


}
